import { KdKanban } from '../@types/State';

export const findKanbanItemFromId = (
  warPlan: KdKanban | undefined,
  id: string | undefined
) => {
  if (!warPlan || !id) {
    return undefined;
  }
  for (const column of warPlan.columns) {
    const item = column.items.find((item) => item.id === id);
    if (item) {
      return item;
    }
  }
  return undefined;
};

export const findKanbanItemFromProvinceId = (
  warPlan: KdKanban | undefined,
  provinceId: number
) => {
  if (!warPlan || !provinceId) {
    return undefined;
  }
  for (const column of warPlan.columns) {
    const item = column.items.find((item) => item.province.id === provinceId);
    if (item) {
      return item;
    }
  }
  return undefined;
};
